import React from 'react';
import { Check, X } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const isFor = ['Profesionales en Latam que quieren dejar de ganar en moneda local y empezar a cobrar en USD/Euros.', 'Personas con inglés básico-intermedio que temen que su nivel de idioma sea una barrera.', 'Administrativos, creativos o perfiles de soporte que saben que pueden dar más en un entorno global.', 'Estudiantes o recién graduados que necesitan su primera oportunidad laboral seria.'];
const notFor = ['Quienes buscan "dinero fácil" haciendo clics o viendo anuncios sin trabajar.', 'Personas que no están dispuestas a dedicar 30 minutos al día a optimizar su presencia digital.', 'Perfiles senior que ya tienen una carrera consolidada en el mercado remoto global.'];
export function WhoIsFor() {
  return <section className="py-24 px-4 bg-navy-800 border-y border-white/5" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="grid lg:grid-cols-2 gap-8" data-id="element-183">
          {/* Who is it for */}
          <FadeIn direction="right" data-id="element-184">
            <div className="bg-navy-900 p-8 md:p-10 rounded-3xl border border-emerald-500/20 h-full" data-id="element-185">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-186">
                <span className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center text-emerald-400" data-id="element-187">
                  <Check className="w-6 h-6" data-id="element-188" />
                </span>
                Este kit ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-189">
                {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-190">
                    <Check className="w-6 h-6 text-emerald-400 shrink-0 mt-0.5" data-id="element-191" />
                    <span className="text-slate-300 text-lg" data-id="element-192">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who is it NOT for */}
          <FadeIn direction="left" delay={0.2} data-id="element-193">
            <div className="bg-navy-900 p-8 md:p-10 rounded-3xl border border-red-500/20 h-full" data-id="element-194">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-195">
                <span className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center text-red-400" data-id="element-196">
                  <X className="w-6 h-6" data-id="element-197" />
                </span>
                Este kit NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-198">
                {notFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-199">
                    <X className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-200" />
                    <span className="text-slate-300 text-lg" data-id="element-201">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}